import React from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';

import './CartProduct.sass';
import ChannelImage from '../../containers/channelUtils/ChannelImage';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';
import Tags from '../tags/Tags';
import FormatDate from '../dates/FormatDate';
import CurrentTimezone from '../dates/CurrentTimezone';

export default class CartProduct extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      removing: false
    };
  }

  onRemove = () => {
    const {id, onRemoveClick} = this.props;
    this.setState({removing: true});

    onRemoveClick(id).then(() => {
      this.setState({removing: false});
    });
  };

  render() {
    const {image, name, price, options, eventOccurrence, modal} = this.props;
    const {removing} = this.state;

    return (
      <div
        className={cx(
          'cart-product',
          modal && 'cart-product--modal',
          removing && 'cart-product--removing'
        )}
      >
        <div className="cart-product__image">
          {image && <ChannelImage src={image} alt={name} />}
        </div>
        <div className="cart-product__desc">
          {eventOccurrence && (
            <div className="cart-product__time">
              <FormatDate date={eventOccurrence} format="DD MMM, HH:mm" /> (<CurrentTimezone />)
            </div>
          )}
          <div className="cart-product__name">{name}</div>
          {options && !!options.length && (
            <div className="cart-product__options">
              <Tags tags={options} />
            </div>
          )}
        </div>
        <div className="cart-product__controls">
          <ChannelPrice component="p" className="cart-product__price" price={price} />
          <button className="cart-product__delete" onClick={this.onRemove} disabled={removing} />
        </div>
      </div>
    );
  }
}

CartProduct.getItemTitle = (item, isCreatedFromAdmin) => {
  if (isCreatedFromAdmin && item.productName) {
    return item.productName;
  }

  if (item.variant.name && item.variant.product.name !== item.variant.name) {
    return `${item.variant.product.name} - ${item.variant.name}`;
  }

  return item.variant.product.name;
};



// WEBPACK FOOTER //
// ./components/cartProduct/CartProduct.js